var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversalAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510.96 131.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .UA_Primary_Logo_Gradient_26 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.62,
    y1: 102.56,
    x2: 101.25,
    y2: -1.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ef1541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a000a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#6e55dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#069de0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.77,84.86v-27.24h10.49v26.97c0,7.76,3.88,11.78,10.28,11.78s10.28-3.88,10.28-11.44v-27.31h10.49v26.9c0,14.44-8.1,21.52-20.91,21.52s-20.63-7.15-20.63-21.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,68.79h10.35v5.18c2.38-3.06,5.45-5.86,10.69-5.86,7.83,0,12.39,5.18,12.39,13.55v23.63h-10.35v-20.36c0-4.9-2.32-7.42-6.27-7.42s-6.47,2.52-6.47,7.42v20.36h-10.35v-36.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.32,55.58h10.9v9.19h-10.9v-9.19ZM148.59,68.79h10.35v36.5h-10.35v-36.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,68.79h10.96l8.17,24.45,8.24-24.45h10.76l-14.37,36.77h-9.4l-14.37-36.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.86,87.25v-.14c0-10.42,7.42-19,18.05-19,12.19,0,17.77,9.47,17.77,19.82,0,.82-.07,1.77-.14,2.72h-25.4c1.02,4.7,4.29,7.15,8.92,7.15,3.47,0,5.99-1.09,8.85-3.75l5.92,5.24c-3.41,4.22-8.31,6.81-14.91,6.81-10.96,0-19.07-7.7-19.07-18.86ZM229.6,84.18c-.61-4.63-3.34-7.76-7.7-7.76s-7.08,3.06-7.9,7.76h15.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.04,68.79h10.35v7.35c2.11-5.04,5.52-8.31,11.65-8.04v10.83h-.54c-6.88,0-11.1,4.15-11.1,12.87v13.48h-10.35v-36.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.74,100.46l4.43-6.81c3.95,2.86,8.1,4.36,11.51,4.36,3,0,4.36-1.09,4.36-2.72v-.14c0-2.25-3.54-3-7.56-4.22-5.11-1.5-10.9-3.88-10.9-10.96v-.14c0-7.42,5.99-11.58,13.35-11.58,4.63,0,9.67,1.57,13.62,4.22l-3.95,7.15c-3.61-2.11-7.22-3.41-9.87-3.41-2.52,0-3.81,1.09-3.81,2.52v.14c0,2.04,3.47,3,7.42,4.36,5.11,1.7,11.03,4.15,11.03,10.83v.14c0,8.1-6.06,11.78-13.96,11.78-5.11,0-10.83-1.7-15.66-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.88,94.81v-.14c0-7.97,6.06-11.65,14.71-11.65,3.68,0,6.33.61,8.92,1.5v-.61c0-4.29-2.66-6.67-7.83-6.67-3.95,0-6.74.75-10.08,1.97l-2.59-7.9c4.02-1.77,7.97-2.93,14.17-2.93,5.65,0,9.74,1.5,12.33,4.09,2.72,2.72,3.95,6.74,3.95,11.65v21.18h-10.01v-3.95c-2.52,2.79-5.99,4.63-11.03,4.63-6.88,0-12.53-3.95-12.53-11.17ZM331.64,92.42v-1.84c-1.77-.82-4.09-1.36-6.61-1.36-4.43,0-7.15,1.77-7.15,5.04v.14c0,2.79,2.32,4.43,5.65,4.43,4.83,0,8.1-2.66,8.1-6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.76,55.58h10.35v49.71h-10.35v-49.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.67,57.28h9.67l20.43,48.01h-10.96l-4.36-10.69h-20.16l-4.36,10.69h-10.69l20.43-48.01ZM416.7,85.34l-6.33-15.46-6.33,15.46h12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.68,87.11v-.14c0-12.19,7.97-18.86,16.62-18.86,5.52,0,8.92,2.52,11.37,5.45v-17.98h10.35v49.71h-10.35v-5.24c-2.52,3.41-5.99,5.92-11.37,5.92-8.51,0-16.62-6.67-16.62-18.86ZM465.81,87.11v-.14c0-6.06-4.02-10.08-8.85-10.08s-8.92,3.95-8.92,10.08v.14c0,6.06,4.09,10.08,8.92,10.08s8.85-4.02,8.85-10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.34,100.46l4.43-6.81c3.95,2.86,8.1,4.36,11.51,4.36,3,0,4.36-1.09,4.36-2.72v-.14c0-2.25-3.54-3-7.56-4.22-5.11-1.5-10.9-3.88-10.9-10.96v-.14c0-7.42,5.99-11.58,13.35-11.58,4.63,0,9.67,1.57,13.62,4.22l-3.95,7.15c-3.61-2.11-7.22-3.41-9.87-3.41-2.52,0-3.81,1.09-3.81,2.52v.14c0,2.04,3.47,3,7.42,4.36,5.11,1.7,11.03,4.15,11.03,10.83v.14c0,8.1-6.06,11.78-13.96,11.78-5.11,0-10.83-1.7-15.66-5.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "UA_Primary_Logo_Gradient_26",
    d: "M22.66,131.92C8.05,117.32,0,97.91,0,77.26,0,34.66,34.66,0,77.26,0c20.64,0,40.04,8.04,54.63,22.63l-7.46,7.46c-12.6-12.6-29.35-19.54-47.17-19.54C40.48,10.55,10.55,40.48,10.55,77.26c0,17.83,6.95,34.59,19.56,47.19l-7.46,7.47Z"
  }), /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 130,
    fontSize: 18,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fill: "#000000"
  }, "\n        Powered by Adrsta AI\n      ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversalAds);
export default __webpack_public_path__ + "static/media/universal-ads.abf52caeca8d772751fbf169a1562161.svg";
export { ForwardRef as ReactComponent };